<template>
    <div class="staff">
        <!--        <el-card>-->
        <!--            <el-breadcrumb separator="/">-->
        <!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
        <!--                <el-breadcrumb-item>商品管理</el-breadcrumb-item>-->
        <!--                <el-breadcrumb-item>商品管理</el-breadcrumb-item>-->
        <!--            </el-breadcrumb>-->
        <!--        </el-card>-->
        <main class="content">
            <!--搜索区-->
            <el-card>
                <el-container>
                    <el-aside width="220px" :style="{height: treeConfig.height + 'px', marginRight: '10px'}">
                        <div ref="treePosition"></div>
                        <el-tree size="mini"
                            :load="loadTree"
                            ref="tree"
                            lazy
                            node-key="id"
                            :props="props"
                            :current-node-key="searchForm.categoryId"
                            highlight-current="true"
                            :expand-on-click-node="false"
                            :default-expanded-keys="['root']"
                            accordion
                            @current-change="changeTreeNode">
                            <div class="custom-tree-node" slot-scope="{ node, data }">
                                <span style="flex-grow: 1; font-size: 12px;">
                                    <span slot="reference"><i v-if="node.data.fid == 'root'" :class="node.data.icon"></i>{{ node.data.name }}</span>
                                </span>
                            </div>
                        </el-tree>
                    </el-aside>
                    <el-main>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="SKU">
                        <el-input v-model="searchForm.sku" placeholder="请输入SKU" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="供应商">
                        <el-input v-model="searchForm.supplier" placeholder="请输入供应商" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="供应商SKU">
                        <el-input v-model="searchForm.supplierSku" placeholder="请输入供应商SKU" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="商品名称">
                        <el-input v-model="searchForm.name" placeholder="商品名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="品牌">
                        <el-input v-model="searchForm.brand" placeholder="商品品牌" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="商品状态" size="mini" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="草稿" value="0"></el-option>
                            <el-option label="待审核" value="1"></el-option>
                            <el-option label="上架" value="3"></el-option>
                            <el-option label="驳回" value="4"></el-option>
                            <el-option label="待下架" value="5"></el-option>
                            <el-option label="下架" value="6"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="锁定销售价">
                        <el-checkbox size="medium" v-model="searchForm.lockPrice"></el-checkbox>
                    </el-form-item>
                    <el-form-item style="padding-left: 10px">
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <!--数据展示区-->
                <div ref="tablePosition"></div>
                <el-table
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    style="width: 100%"
                    size="mini"
                    :row-class-name="rowClassName"
                    @selection-change="handleSelectionChange"
                    :height="tableConfig.height"
                >
                    <el-table-column type="selection" width="55" fixed/>
                    <el-table-column prop="sku" label="SKU" width="120" fixed="left"/>
                    <el-table-column prop="name" label="名称" min-width="200"/>
                    <el-table-column prop="brandNameCh" label="品牌" width="100"/>
                    <el-table-column prop="delivery" label="货期(天)" width="80"/>
                    <el-table-column prop="unit" label="单位" width="80"/>
                    <el-table-column prop="supplierOfficialPrice" label="面价(元)" width="120" align="right" :formatter="formatterMoney"/>
                    <el-table-column prop="supplierUntaxedPrice" label="未税采购单价(元)" width="120" align="right" :formatter="formatterMoney"/>
                    <el-table-column prop="supplierPrice" label="含税采购单价(元)" width="120" align="right" :formatter="formatterMoney"/>
                    <el-table-column label="未税销售单价(元)" align="center" >
                        <el-table-column prop="calcUntaxedPrice" width="90" label="测算价" align="center" :formatter="formatterMoney" ></el-table-column>
                        <el-table-column prop="untaxedPrice" width="90" label="销售价" align="center" :formatter="formatterMoney" ></el-table-column>
                    </el-table-column>
                    <el-table-column label="含税销售单价(元)" align="center" >
                        <el-table-column prop="calcPrice" width="90" label="测算价" align="center" :formatter="formatterMoney" ></el-table-column>
                        <el-table-column prop="price" width="90" label="销售价" align="center" :formatter="formatterMoney" ></el-table-column>
                    </el-table-column>
                    <el-table-column prop="supplier" label="供应商" width="200"/>
                    <el-table-column prop="supplierSku" label="供应商SKU" width="200"/>
                    <el-table-column prop="status" label="状态" width="80">
                        <template slot-scope="scope">
                            <el-tag type="danger" v-if="scope.row.status == 0">草稿</el-tag>
                            <el-tag type="warning" v-if="scope.row.status == 1">待审核</el-tag>
                            <el-tag type="success" v-if="scope.row.status == 3">上架</el-tag>
                            <el-tag type="warning" v-if="scope.row.status == 4">驳回</el-tag>
                            <el-tag type="warning" v-if="scope.row.status == 5">待下架</el-tag>
                            <el-tag type="info" v-if="scope.row.status == 6">下架</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="250" align="right" fixed="right">
                        <template slot="header" slot-scope="header">
                            <a href="/template/上传商品示例.zip" style="margin-right:16px">下载模板</a>
                            <el-button type="primary" @click="handleUpload" size="mini">批量上传</el-button>
                            <el-dropdown style="margin-left: 8px;" @command="more">
                                <el-button type="primary" size="mini">
                                    操作<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="add">添加商品</el-dropdown-item>
                                    <el-dropdown-item command="publish">批量上架</el-dropdown-item>
                                    <el-dropdown-item command="off">批量下架</el-dropdown-item>
                                    <el-dropdown-item command="exportAll">导出全部</el-dropdown-item>
                                    <el-dropdown-item command="exportSelected">导出所选</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <!-- <el-button type="primary" @click="handleCreate" size="mini">添加</el-button> -->
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="preview(scope.$index, scope.row)">预览</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :total="total"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-main>
            </el-container>
            </el-card>
        </main>
        <el-dialog title="导入物料号" :modal="true" :visible.sync="uploadDialogVisible" width="400px">
            <el-upload ref="upload"
                       class="upload-demo"
                       drag
                       action="/api/admin/product/upload"
                       :limit="1"
                       accept=".zip"
                       :on-success="uploadSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div v-html="uploadCheckResult"></div>
        </el-dialog>
    </div>
</template>
<script>
import { downloadByPost, convertRes2Blob } from '../../utils/download.js';
import store from '../../store';
const HEIGHT_OFFSET = 118;
export default {
    data() {
        return {
            props: {
                id: "id",
                label: 'name',
                children: 'children',
                isLeaf: 'leaf'
            },
            tableConfig: {
                height: 0,
            },
            treeConfig: {
                height: 0,
            },
            searchForm: {
                categoryLevel: 0,
                categoryId: "root",
                sku: "",
                supplier: "",
                supplierSku: "",
                name: "",
                brand: "",
                status: "",
                lockPrice: false
            },
            rejectForm: {
                id: "",
                reason: "",
            },
            statusOptions: [
                {
                    value: "",
                    label: "全部",
                },
                {
                    value: "0",
                    label: "下架",
                },
                {
                    value: "1",
                    label: "上架",
                },
            ],
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            uploadCheckResult: "",
            rejectDialogVisible: false,
            uploadDialogVisible: false,
            selectData: [],
            searchFormStash: {},
        }
    },
    // computed: {
    //     tableHeight() {
    //         return this.$store.state.clientHeight - 320;
    //     }
    // },
    methods: {
        onSearch() {

            let params = {};
            if (this.searchForm.name != "") {
                params["name"] = this.searchForm.name;
            }
            if (this.searchForm.sku != "") {
                params["sku"] = this.searchForm.sku;
            }
            if (this.searchForm.supplier != "") {
                params["supplier"] = this.searchForm.supplier;
            }
            if (this.searchForm.supplierSku != "") {
                params["supplierSku"] = this.searchForm.supplierSku;
            }
            if (this.searchForm.status != "") {
                params["status"] = this.searchForm.status;
            }
            if (this.searchForm.brand) {
                params["brand"] = this.searchForm.brand;
            }
            if(this.searchForm.lockPrice) {
                params["lockPrice"] = this.searchForm.lockPrice;
            }
            if(this.searchForm.categoryId !== 'root') {
                params["categoryId"] = this.searchForm.categoryId;
                params["categoryLevel"] = this.searchForm.categoryLevel;
            }

            this.searchFormStash = {...params};
            this.loading = true;
            let _this = this
            this.$axios.post("/admin/product/search", {
                cond: params,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function () {
            });
        },
        handleCreate() {
            this.$router.push({ name: "addOneProduct", params: { title:'新建商品' } });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        preview(index, row) {
            window.open(`${store.getters.getDomain}/item?id=${row.id}`, "_blank");
        },
        handleEdit(index, row) {
            this.$router.push({ name: "addOneProduct", params: { title:'编辑商品' }, query: { id: row.id } });
        },
        handleUpload() {
            this.uploadDialogVisible = true;
        },
        uploadSuccess(response) {
            const {header: {status, msg}} = response;
            this.$refs.upload.clearFiles();
            if(status === 0) {
                this.$notify({
                    title: '成功',
                    message: '数据保存成功',
                    type: 'success'
                });
                this.uploadDialogVisible = false;
                this.onSearch();
            } else {
                this.uploadCheckResult = msg;
            }
        },
        formatterMoney(row, col, value) {
            if(value) {
                return this.MoneyFormat(value, "", 2);
            } else {
                return "-";
            }
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        more(command) {
            const that = this;
            switch(command) {
                case 'add':
                    this.handleCreate();
                    break;
                case 'publish':
                    // this.loading = true;
                    this.$confirm('确定上架已选择商品吗？', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        that.$axios.post("/admin/product/publish",
                            that.selectData.map(it => it['id']),
                        ).then(function (response) {
                            let resp = response.data;
                            if (resp.header.status !== 0) {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                            that.onSearch();
                        }).finally(() => {
                        });
                    });
                    break;
                case 'off':
                    // this.loading = true;
                    this.$confirm('确定下架已选择商品吗？', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        that.$axios.post("/admin/product/off",
                            that.selectData.map(it => it['id']),
                        ).then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                that.onSearch();
                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        }).finally(() => {
                        });
                    });
                    break;
                case 'exportAll':
                case 'exportSelected':
                    this.export(command);
                    break;
            }

        },
        export(command) {
            let data = {};
            switch(command) {
                case 'exportAll': {
                    if(this.total > 5000) {
                        this.$notify.info({
                            title: '提示',
                            message: '一次最多导出5000条数据',
                        });
                        return;
                    }
                    data = {...this.searchFormStash};
                    break;
                }
                case 'exportSelected': {
                    if (this.selectData.length == 0) {
                        this.$message({
                            type: 'error',
                            message: '请选择要导出的订单',
                            duration: 2000
                        });
                        return;
                    }
                    if(this.selectData.length > 5000) {
                        this.$notify.info({
                            title: '提示',
                            message: '一次最多导出5000条数据',
                        });
                        return;
                    }
                    data = {ids: this.selectData.map(it => it.id)};
                    break;
                }
            }
            this.loading = true
            downloadByPost({
                axios: this.$axios,
                url: command === 'exportAll' ? "/admin/product/exportAll" : "/admin/product/export",
                data,
                success: response => {
                    convertRes2Blob(response);
                },
                complete: () => {
                    this.loading = false;
                }
            });
        },
        rowClassName({row, rowIndex}) {
            if(row.lockPrice && row.calcPrice >= row.price){
                return 'warnprice'
            }
            else {
                return ''
            }
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
        setTreeHeight() {
            const treePosition = this.$refs['treePosition'];
            const {top} = treePosition.getBoundingClientRect();
            this.treeConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
        loadTree(node, resolve) {
            if(node.level === 0) {
                resolve([{id: "root", name: "全部产品分类", type: 0, description: "", uri: "-", status: 1, level: -1, isLeaf: false}]);
            } else {
                this.loading = true;
                let _this = this;
                this.$axios.post("/admin/product/category/list", {
                    fid: node.data.id,
                }).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        resolve(resp.data.map(it => ({...it, leaf: (it.children || []).length === 0})));
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                    _this.loading = false;
                }).catch(function(error) {
                    _this.loading = false;
                });
            }
        },
        changeTreeNode(data, node) {
            if(this.searchForm.categoryId !== node.data.id) {
                this.searchForm.categoryId = node.data.id;
                this.searchForm.categoryLevel = node.data.level;
                this.currentPage=1;
                this.onSearch();
            }
        },
    },
    created() {
        this.onSearch();
        window.addEventListener("resize", this.setTableHeight);
        window.addEventListener("resize", this.setTreeHeight);
    },
    activated() {
        setTimeout(() => {
            this.setTableHeight();
            this.setTreeHeight();
        }, 500);
    },
    mounted() {
        setTimeout(() => {
            this.setTableHeight();
            this.setTreeHeight();
        }, 500);
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
        window.removeEventListener("resize", this.setTreeHeight);
    },
}
</script>
<style>
    .el-table .warnprice {
        background: rgb(255 232 198);
    }
</style>
